import { render } from "./AppFoot.vue?vue&type=template&id=1058860e"
const script = {}

import "./AppFoot.vue?vue&type=style&index=0&id=1058860e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__